import { render, staticRenderFns } from "./LeaveVoucher.vue?vue&type=template&id=ba61ef4a&"
import script from "./LeaveVoucher.vue?vue&type=script&lang=js&"
export * from "./LeaveVoucher.vue?vue&type=script&lang=js&"
import style0 from "./LeaveVoucher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports